import { render, staticRenderFns } from "./RatesItemDetails.vue?vue&type=template&id=6ba418dc&scoped=true&"
import script from "./RatesItemDetails.vue?vue&type=script&lang=js&"
export * from "./RatesItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./RatesItemDetails.vue?vue&type=style&index=0&id=6ba418dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba418dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba418dc')) {
      api.createRecord('6ba418dc', component.options)
    } else {
      api.reload('6ba418dc', component.options)
    }
    module.hot.accept("./RatesItemDetails.vue?vue&type=template&id=6ba418dc&scoped=true&", function () {
      api.rerender('6ba418dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/RatesItemDetails.vue"
export default component.exports